import { render, staticRenderFns } from "./CommunicationsCloud.vue?vue&type=template&id=1c177228"
import script from "./CommunicationsCloud.vue?vue&type=script&lang=js"
export * from "./CommunicationsCloud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports